export default () => ({
  '-1': '13px',
  '0': '0px',
  '1': '14px',
  '2': '16px',
  '3': '18px',
  '4': '22px',
  '5': '28px',
  '6': '42px',
  '7': '60px',
  root: '14px',
});
